export default __webpack_public_path__ + "static/media/privacy_lock.f85eb8c6.svg";